<script setup lang="ts">
import { useTheme } from '@/stores/theme';
import { LoaderTabs } from '@dh-io-owpi/vehicle-features/src/lib';

const theme = useTheme();
</script>
<template>
  <LoaderTabs class="owpi-section-features-skeleton" :darkMode="theme.dark" />
</template>
<style lang="scss">
.owpi-section-features-skeleton {
  max-width: var(--wb-grid-width);
  margin-inline: auto;
}
</style>
